import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useUser } from "./UserContext";
import { data, Link, useNavigate } from 'react-router-dom';
import UserDropdown from "./UserDropdown";
import { FaTwitch, FaBars, FaTimes } from "react-icons/fa";
import TwitchLiveLink from "./TwitchLiveLink";


const CLIENT_ID = "dc5o9xs32z5di1jjviy56vhmlqvjnc";
const REDIRECT_URI = "https://seedsmash.ai/callback"; // Update for production
//const REDIRECT_URI = "http://localhost:3000/callback"; // Update for production
const SCOPES = "user:read:email";

const handleLogin = () => {
  const twitchAuthUrl = `https://id.twitch.tv/oauth2/authorize?client_id=${CLIENT_ID}&force_verify=true&redirect_uri=${encodeURIComponent(
    REDIRECT_URI
  )}&response_type=token&scope=${SCOPES}`;
  window.location.href = twitchAuthUrl;
};

const fetchTwitchUser = async (token) => {

  try {
    const response = await axios.get("https://api.twitch.tv/helix/users", {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Client-Id": "dc5o9xs32z5di1jjviy56vhmlqvjnc",
      },
    });

    if (response.data && response.data.data.length > 0) {
      return response.data.data[0]; // User info is in the first element of the `data` array
    } else {
      throw new Error("No user data found.");
    }

  } catch (error) {
    //console.error("Error fetching user data:", error);
  }
};


const Navbar = () => {
  const { user, setUser } = useUser();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);


  useEffect(() => {
    const token = localStorage.getItem("twitchToken");

    if (token && !user) {
      fetchTwitchUser(token).then((userData) => {
        if (userData) {
          setUser(userData);
        }
      });
    }
  }, [user, setUser]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const trySubmitBot = () => {
    if (user) {
      navigate("/submit-seed")
    } else {
      handleLogin();
    }
  };

  return (
    <nav className="bg-gray-900/80 text-indigo-50 p-4 shadow-md fixed top-0 w-full z-50">
    <div className="max-w-7xl min-w-xl mx-auto flex items-center justify-between relative">
      
      {/* Mobile Menu Toggle */}
      <button 
        className="sm:hidden text-white text-2xl focus:outline-none z-10" 
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Left Section - Links */}
      <div className="hidden sm:flex items-center space-x-8">
        <Link to="/leaderboard" className="flex-shrink-0 z-10">
          <div className="px-4 py-2 hover:text-pink-200 duration-200 ease-in-out">
            <span>Leaderboard</span>
          </div>
        </Link>
        
       <TwitchLiveLink/>
      </div>

      {/* Center Section - Logo */}
      <Link to="/" className="absolute inset-x-0 mx-auto text-center">
        <h1 className="text-2xl font-bold text-white relative">
          seedsmash.ai
          <span className="absolute inset-0 text-blue-700 blur-sm opacity-80 -z-10">
            seedsmash.ai
          </span>
        </h1>
      </Link>

      {/* Right Section - Buttons */}
      <div className="hidden sm:flex items-center space-x-6 z-10">
        <button
          className="px-4 py-2 hover:text-pink-200 duration-200 ease-in-out"
          onClick={trySubmitBot}
        >
          <span>Submit Your Seed</span>
        </button>
        {user ? (
          <UserDropdown />
        ) : (
          <button
            className="border-[#6441a5] bg-[#6441a5]/40 px-2 py-2 text-white hover:bg-[#6441a5]/70 focus:ring-[#6441a5] duration-200 ease-in-out flex items-center gap-2 rounded-md"
            onClick={handleLogin}
          >
            <FaTwitch />
            Login
          </button>
        )}
      </div>
    </div>

    {/* Mobile Menu */}
    {isOpen && (
      <div ref={dropdownRef} className="sm:hidden absolute rounded-lg top-16 left-2 w-1/2 grid grid-cols-1 grid-rows-4 gap-1 items-center bg-gray-950/95 border border-pink-300/30 transition z-50">
        <Link
          to="/leaderboard"
          className="py-2 text-center hover:text-pink-200"
          onClick={() => setIsOpen(false)}
        >
          Leaderboard
        </Link>
        <span className="flex items-center justify-center space-x-2">
          <FaTwitch />
          <a
            href="https://www.twitch.tv/seedsmash"
            target="_blank"
            rel="noreferrer"
            className="py-2 text-center hover:text-pink-200"
            onClick={() => setIsOpen(false)}
          >
            Watch Live!
          </a>
        </span>
        <button
          className="py-2 text-center hover:text-pink-200"
          onClick={() => {
            setIsOpen(false);
            trySubmitBot();
          }}
        >
          Submit Your Seed
        </button>
        {user ? (
          <div className="flex justify-center items-center py-2">
          <UserDropdown setIsParentOpen={setIsOpen}/>
          </div>
        ) : (
          <button
            className="flex justify-center items-center space-x-2 py-2 text-center border-[#6441a5] bg-[#6441a5]/40 text-white hover:bg-[#6441a5]/70 rounded-md max-w-2/3 px-4 my-1 mx-auto"
            onClick={() => {
              setIsOpen(false);
              handleLogin();
            }}
          >
            <FaTwitch />
            <span>Login</span>
          </button>
        )}
      </div>
    )}
  </nav>
  );
  
};

export default Navbar;